import { render, staticRenderFns } from "./informationBi.vue?vue&type=template&id=04588236&scoped=true&"
import script from "./informationBi.vue?vue&type=script&lang=js&"
export * from "./informationBi.vue?vue&type=script&lang=js&"
import style0 from "./informationBi.vue?vue&type=style&index=0&id=04588236&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04588236",
  null
  
)

export default component.exports